// Azure App Service Client namespace
var WindowsAzure: any;

var appServiceClient: any;

module App {
  "use strict";

  export interface ExceptionObject {
    msg: string;
    line: number;
    col: number;
    url: string;
  };

  
  export class Application {

    public static AppBackend: string = 'cornellupu';
    
    orchestrator: App.Orchestrator;

    constructor() {

      appServiceClient = new WindowsAzure.MobileServiceClient(`https://${Application.AppBackend}.azurewebsites.net`);

      this.orchestrator = new App.Orchestrator();

      if ('serviceWorker' in navigator) {
        try {

          navigator.serviceWorker.register('sw.js').then(() => {
            console.log('service worker registered');
          });
        } catch (e) {
          console.log('service worker failed to register!!');
        }
      }
    }
  }
}

let app: App.Application = null;

window.onload = function (): void {

  app = new App.Application();
};


window.onerror = function (msg: string, url: string, line: number, col: number, err: any): boolean {

  let content: App.ExceptionObject = {
    msg: msg,
    line: line,
    col: col,
    url: url
  };

  let contentStr: string = JSON.stringify(content);

  // save the exception
  window.localStorage.setItem("exception", contentStr);

  // check out the json online at: http://jsoneditoronline.org/
  if (app && app.orchestrator) {
    window.localStorage.setItem("exceptionDump", app.orchestrator.dump());
  }

  return false;
};